import type { ApiError } from '@aithora/shared';

/**
 * The spec's error state: a plain sentence, a retry and the request id, so a support
 * conversation is possible.
 */
export function ErrorNote({ error, onRetry, compact }: { error: ApiError; onRetry?: () => void; compact?: boolean }) {
  return (
    <div className={`errornote${compact ? ' errornote--compact' : ''}`} role="alert">
      <span className="errornote__msg">{error.message}</span>
      {onRetry && (
        <button type="button" className="linkbtn" onClick={onRetry}>
          Try again
        </button>
      )}
      <span className="errornote__rid">{error.requestId ? `Request ${error.requestId}` : 'No request id'}</span>
    </div>
  );
}
